/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountStatusResponse } from '../models/AccountStatusResponse';
import type { UnlockAccountRequest } from '../models/UnlockAccountRequest';
import type { UnlockAccountResponse } from '../models/UnlockAccountResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccountRecoveryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Account Status
     * Get account lockout status for a user.
     *
     * Args:
     * email: User's email address
     * db: Database session
     *
     * Returns:
     * AccountStatusResponse: Account lockout information
     * @param email
     * @returns AccountStatusResponse Successful Response
     * @throws ApiError
     */
    public getAccountStatusAccountStatusEmailGet(
        email: string,
    ): CancelablePromise<AccountStatusResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/account/status/{email}',
            path: {
                'email': email,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Account Status
     * Get account lockout status for a user.
     *
     * Args:
     * email: User's email address
     * db: Database session
     *
     * Returns:
     * AccountStatusResponse: Account lockout information
     * @param email
     * @returns AccountStatusResponse Successful Response
     * @throws ApiError
     */
    public getAccountStatusAccountStatusEmailGet1(
        email: string,
    ): CancelablePromise<AccountStatusResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/account/status/{email}',
            path: {
                'email': email,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unlock Account
     * Unlock a user account that has been locked due to failed login attempts.
     *
     * This endpoint provides a way to recover from account lockouts without
     * requiring admin intervention for legitimate users.
     *
     * Args:
     * unlock_request: Unlock request with email and reason
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * UnlockAccountResponse: Unlock result
     * @param requestBody
     * @returns UnlockAccountResponse Successful Response
     * @throws ApiError
     */
    public unlockAccountAccountUnlockPost(
        requestBody: UnlockAccountRequest,
    ): CancelablePromise<UnlockAccountResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/account/unlock',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unlock Account
     * Unlock a user account that has been locked due to failed login attempts.
     *
     * This endpoint provides a way to recover from account lockouts without
     * requiring admin intervention for legitimate users.
     *
     * Args:
     * unlock_request: Unlock request with email and reason
     * request: FastAPI request object
     * db: Database session
     *
     * Returns:
     * UnlockAccountResponse: Unlock result
     * @param requestBody
     * @returns UnlockAccountResponse Successful Response
     * @throws ApiError
     */
    public unlockAccountAccountUnlockPost1(
        requestBody: UnlockAccountRequest,
    ): CancelablePromise<UnlockAccountResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/account/unlock',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reset Failed Attempts
     * Reset failed login attempts for a user (admin only).
     *
     * Args:
     * email: User's email address
     * db: Database session
     *
     * Returns:
     * Success message
     * @param email
     * @returns any Successful Response
     * @throws ApiError
     */
    public resetFailedAttemptsAccountResetFailedAttemptsPost(
        email: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/account/reset-failed-attempts',
            query: {
                'email': email,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Reset Failed Attempts
     * Reset failed login attempts for a user (admin only).
     *
     * Args:
     * email: User's email address
     * db: Database session
     *
     * Returns:
     * Success message
     * @param email
     * @returns any Successful Response
     * @throws ApiError
     */
    public resetFailedAttemptsAccountResetFailedAttemptsPost1(
        email: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/account/reset-failed-attempts',
            query: {
                'email': email,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Lockout Policy
     * Get the current account lockout policy information.
     *
     * Returns:
     * Lockout policy details
     * @returns any Successful Response
     * @throws ApiError
     */
    public getLockoutPolicyAccountLockoutPolicyGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/account/lockout-policy',
        });
    }
    /**
     * Get Lockout Policy
     * Get the current account lockout policy information.
     *
     * Returns:
     * Lockout policy details
     * @returns any Successful Response
     * @throws ApiError
     */
    public getLockoutPolicyAccountLockoutPolicyGet1(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/account/lockout-policy',
        });
    }
}
